import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { selectExtendedUsers } from 'store/users/selectors';

import { formatHistoryDate, getActorLabel } from '../../ConditionHistoryDrawer.utils';
import PropertyRow from '../PropertyRow';

import { entryHeaderStyles, entryStyles } from './HistoryEntry.styles';

const HistoryEntry = ({ entry }) => {
  const users = useSelector(selectExtendedUsers);

  const {
    actionType,
    actorType,
    changedByUserId,
    createdDate,
    properties,
    loanConditionHistoryEntryId,
  } = entry;

  const actorLabel = getActorLabel({
    actorType,
    changedByUserId,
    userName: users[changedByUserId]?.name,
  });

  return (
    <Box sx={entryStyles}>
      <Box sx={entryHeaderStyles}>
        <Typography color="text.primary" variant="medium14">
          {actionType}
        </Typography>
        <Typography color="text.secondary" variant="regular12">
          {formatHistoryDate(createdDate)}
        </Typography>
      </Box>

      <Typography color="text.secondary" variant="regular12">
        {actorLabel}
      </Typography>

      {properties?.map(({ propertyName, oldValue, newValue }) => (
        <PropertyRow
          key={`${loanConditionHistoryEntryId}.${propertyName}`}
          newValue={newValue}
          oldValue={oldValue}
          propertyName={propertyName}
        />
      ))}
    </Box>
  );
};

HistoryEntry.propTypes = {
  entry: PropTypes.shape({
    loanConditionHistoryEntryId: PropTypes.string.isRequired,
    actionType: PropTypes.string,
    actorType: PropTypes.string,
    changedByUserId: PropTypes.string,
    createdDate: PropTypes.string,
    properties: PropTypes.arrayOf(
      PropTypes.shape({
        propertyName: PropTypes.string,
        oldValue: PropTypes.string,
        newValue: PropTypes.string,
      }),
    ),
  }).isRequired,
};

export default memo(HistoryEntry);
